module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0028.7be00228.jpg";